<template>
  <transition appear name="fade">
    <div>
      <appHeader></appHeader>
      <div class="container-fluid p-3 product-page">
        <div class="row">
          <div class="col-12 col-lg-3 col-sm-12">
            <appProductSidebar></appProductSidebar>
          </div>
          <form class="col-12 col-lg-9 product-page" v-on:submit.prevent="">
            <h3 class="w-100">Request custom item</h3>
            <p>Can’t find an item you’re looking for? please tell us that item and we’ll get it for you.</p>
            <div class="row col-12">
              <div class="col-2 col-sm-1 pr-0">
                <div class="badge round-badge">1</div>
              </div>
              <div class="col-10 col-sm-5 mb-3 pl-sm-0">
                <label>Name of item</label>
                <b-form-input v-model="itemName" class="form-control" placeholder="What item are you looking for?" required type="text">
                </b-form-input>
                <div class="invalid-feedback">Valid item name is required.</div>
              </div>
              <div class="col-2 col-sm-1 pr-0">
                <div class="badge round-badge">2</div>
              </div>
              <div class="col-10 col-sm-5 mb-3 pl-sm-0">
                <label>Points amount you'd be willing spend</label>
                <b-form-input v-model.number="itemValue" class="form-control" min="0" required type="number">
                </b-form-input>
                <div class="invalid-feedback">Points amount is required.</div>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-2 col-sm-1 pr-0">
                <div class="badge round-badge">3</div>
              </div>
              <div class="col-10 col-sm-5 mb-3 pl-sm-0">
                <label>Additional information</label>
                <b-form-input v-model="additionalInfo" class="form-control" placeholder="ie. color, model, size" type="text">
                </b-form-input>
              </div>
              <div class="col-2 col-sm-1 pr-0">
                <div class="badge round-badge">4</div>
              </div>
              <div class="col-10 col-sm-5 mb-3 pl-sm-0">
                <label>How many of them would you want</label>
                <b-form-input v-model.number="itemCount" class="form-control" min="0" required type="number">
                </b-form-input>
                <div class="invalid-feedback">Quantity is required.</div>
              </div>
            </div>
            <div class="col-12 text-right">
              <button class="btn btn-primary btn-lg btn-sm-block" v-on:click="postCustomItemRequest">
                <font-awesome-icon icon="shopping-cart"/>
                Request custom item
              </button>
            </div>
          </form>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
  </transition>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import ProductSidebar from './ProductSidebar.vue'

export default {
  data () {
    return {
      itemName: '',
      additionalInfo: '',
      itemValue: '',
      itemCount: ''
    }
  },
  methods: {
    postCustomItemRequest: function () {
      this.$store
          .dispatch('category/addCustomItemRequest', {
            name: this.itemName,
            points: this.itemValue,
            info: this.additionalInfo,
            quantity: this.itemCount
          })
          .then(() => {
            this.showSuccess('Request sent', this.clearFields)
          })
          .catch(() => {
            this.showError('Failed to send request')
          })
    },
    clearFields: function () {
      this.itemName = ''
      this.additionalInfo = ''
      this.itemValue = ''
      this.itemCount = ''
    },
    showSuccess: function (message, onClose) {
      this.$bvModal.msgBoxOk(message, {
        size: 'sm',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
          .then(() => {
            onClose()
          })
    },
    showError: function (message) {
      this.$bvModal.msgBoxOk(message, {
        size: 'sm',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        okVariant: 'danger',
        centered: true
      })
    }
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appProductSidebar: ProductSidebar
  },
  created () { }
}
</script>

<style lang="scss">
.modal-body{
  padding: 2rem 2rem 0 2rem !important;
}
</style>
